'use strict';

module.exports = {
    BREAKPOINTS: {
        MOBILE_MAX: 767,
        TABLET_MIN: 768,
        TABLET_MAX: 1023,
        DESKTOP_MIN: 1024,
        DESKTOP_MAX: 1279
    },
    SLICK: {
        PREV_ARROW:
            '<div class="slick-prev"><i class="icon icon-arrow_left" aria-label="next" tabindex="0"><!-- icon --></i></div>',
        NEXT_ARROW:
            '<div class="slick-next"><i class="icon icon-arrow_right" aria-label="next" tabindex="0"><!-- icon --></i></div>'
    }
};
